/**
 * Consultations Service
 */

import { API_ENDPOINTS } from '@/constants/api';
import { apiClient, ApiResponse } from './apiClient';

export interface OnDemandRequestDTO {
  attendanceMode: 'TELEMEDICINE' | 'HOME_CARE';
  reason: string;
  symptoms?: string;
  paymentId: string;
}

export interface OnDemandResponse {
  queueId: string;
  doctorId: string;
}

/**
 * Request an on-demand consultation
 */
export async function requestOnDemandConsultation(
  data: OnDemandRequestDTO,
): Promise<ApiResponse<OnDemandResponse>> {
  return apiClient.post(API_ENDPOINTS.CONSULTATIONS.ON_DEMAND, data);
}

/**
 * Exit on-demand queue (soft-cancel). Idempotent.
 */
export async function cancelOnDemandConsultation(): Promise<
  ApiResponse<{ cancelledCount: number; cancelledIds: string[] }>
> {
  return apiClient.post(API_ENDPOINTS.CONSULTATIONS.ON_DEMAND_CANCEL);
}
